import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    title: "¿Prefieres salir?",
    subtitle: (country: string) => `Próximos eventos en ${country}`,
    seeMore: "Ver más eventos",
  },
  en: {
    title: "Feel like going out?",
    subtitle: (country: string) => `Upcoming events in ${country}`,
    seeMore: "See more events",
  },
});
